import type { JSX } from 'react'

import { useUnit } from 'effector-react'
import * as era from '~/core/era'
import { ui } from '~/core/skin'
import { ModuleAppTitle } from '~/features/appearance'
import { STATIC_IDENTIFIERS } from '~/shared/appearance'
import { $isEpgEmptyPage } from '../model'

export function Title(): JSX.Element {
  return (
    <ModuleAppTitle identifier={STATIC_IDENTIFIERS.EPG} fallbackKey='epg' />
  )
}

const skin = era.skin('routes/epg/root')

EpgPage.displayName = 'EpgPage'
export function EpgPage(): JSX.Element {
  const isEmptyPage = useUnit($isEpgEmptyPage)

  // the empty state centres itself with `flexGrow`, which needs a flex parent
  return (
    <ui.SkinContext value={skin}>
      <ui.PageWrapper
        className={isEmptyPage ? 'epg-page flex-column' : 'epg-page'}
      >
        <ui.RenderSkin name='epg' />
      </ui.PageWrapper>
    </ui.SkinContext>
  )
}
